import { Tag, Typography } from "antd";
import { Link, useParams } from "react-router-dom";

const { Title, Paragraph, Text } = Typography;

/**
 * Pantalla de andamio: confirma que router, tema y locale estan cableados.
 *
 * Es temporal por diseno. Cada fase la va reemplazando por la pantalla de
 * verdad, y desaparece del repo cuando la ultima ruta tenga la suya.
 */
export const Andamio = ({ ruta, fase }: { ruta: string; fase: string }) => {
  const { cvId } = useParams();

  return (
    <main
      style={{
        maxWidth: 640,
        margin: "0 auto",
        padding: "72px 24px",
        display: "flex",
        flexDirection: "column",
        gap: 16,
      }}
    >
      <img src="/logo-almia.svg" alt="Almia" width={140} />

      <div>
        <Tag color="purple">{fase}</Tag>
        <Tag>{ruta}</Tag>
        {cvId ? <Tag color="orange">cvId: {cvId}</Tag> : null}
      </div>

      <Title level={2} style={{ margin: 0 }}>
        Editor de hojas de vida
      </Title>

      <Paragraph type="secondary" style={{ margin: 0 }}>
        Andamio de la fase F0. El builder de siete pasos sigue intacto en{" "}
        <Text code>src/</Text> y se levanta con{" "}
        <Text code>npm run dev:legacy</Text>.
      </Paragraph>

      <Paragraph style={{ margin: 0 }}>
        Rutas: <Link to="/">subida</Link> ·{" "}
        <Link to="/editor/1">editor</Link> ·{" "}
        <Link to="/revisar/1">revisión</Link>
      </Paragraph>
    </main>
  );
};
